"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AmplifierOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AmplifierOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.067a.5.5 0 0 0-.683.183l-1 1.732a.5.5 0 0 0 .866.5l1-1.732a.5.5 0 0 0-.183-.683ZM13.829 4.99a.5.5 0 0 1 .5.867l-2.598 1.5a.5.5 0 1 1-.5-.866l2.598-1.5ZM15.498 10.09a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.678 3.533a1 1 0 0 1 1.75-.033l5.19 8.99a1 1 0 0 1-.903 1.5l-4.949-.185a1 1 0 0 0-.537.134l-1.437.83a1.083 1.083 0 0 1-1.48-.397L.146 10.618A1.083 1.083 0 0 1 .542 9.14l1.437-.83a1 1 0 0 0 .384-.398l2.315-4.378Zm-1.565 5.1a1 1 0 0 1-.385.399l-.026.015 2.25 3.897.026-.015a1 1 0 0 1 .538-.134l5.236.196L5.562 4l-2.45 4.633Zm-2.071 1.373.794-.46 2.25 3.898-.794.459a.083.083 0 0 1-.113-.03L1.01 10.117a.083.083 0 0 1 .03-.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AmplifierOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AmplifierOutline;
exports["default"] = _default;